<template>
  <div class="content">
    <van-cell-group>
      <div class="question">
        2.在您临床最近<span>【诊断过程中】</span>碰到的<span>10个疑似食物过敏</span>患儿，大约有多少个采用了<span>食物回避2-6周</span>的方法诊断（单选）</div>
      <div class="options">  
        <van-radio-group v-model="answerObj.value" direction="horizontal" @change="changeRemark">
          <van-radio v-for="item in options" :key="item" :name="item" style="margin-right:30px;">{{ item }}</van-radio>
        </van-radio-group>
      </div>
    </van-cell-group>
  </div>
</template>
<script>
import API from "@/api/common";
export default {
  name: 'typingFirst',
  data() {
    return {
      options: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      confirm: '',
      coverUrl: '',
      defaultCoverUrl: require('../../../../assets/images/typing.jpg'),
      answerObj: {
        sort: '1.b',
        title: '临床上为了明确诊断，针对疑似食物过敏的患儿，食物回避多久后会建议患儿进行第一次随诊？',
        remark: '',
        value: ''
      },
    };
  },
  created() {
    
  },
  methods: {
    changeRemark(e) {
      // console.log(this.answerObj)
      this.$emit('getFirstB', e)
      this.confirm = ''
    },
    next() {
      this.answers[5].seq = 'F、' + this.form.other
      this.answerObj = {
        sort: '1.a',
        title: this.title,
        answers: this.answers
      }
      localStorage.setItem('typingFirst', JSON.stringify(this.answerObj))
      if (this.answers[3].percent > 0) {
        this.$router.push({
          name: "typingSecond",
        });
      } else {
        this.$router.push({
          name: "typingThird",
          query: { jump: true, },
        });
      }
    }
  },
};
</script>

<style lang="less" scoped>
.content {
  .question {
    span {
        color: purple;
        font-weight: bold;
    }
  }
  .options {
    /deep/ .el-radio {
      margin-bottom: 10px;
      margin-right: 20px;
      color: #333;
      white-space: normal;
    }
      // padding: 10px 10px;
      font-size: 15px;
      // margin: 5px 0;
  }
  .operation {
      margin: 10px;
      display: flex;
      justify-content: space-between;
      .total {
          font-size: 16px;
          font-weight: bold;
          line-height: 28px;
      }
  }
}
</style>
